import { cardeal } from './api';

export class ExtratoSaldoContaService {
  getExtratoSaldoContaParticipante = async (matricula, plano, anomes) => {
    const response = await cardeal.get('ObterDadosCardInicial', {
      params: {
        matricula,
        plano,
        anomes,
      },
    });

    return response.data;
  };
}
